export function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}
export var formatDate = function (format, timestamp) {
    if (format === void 0) { format = 'Y-M-D h:m:s'; }
    if (timestamp === void 0) { timestamp = Date.now(); }
    var date = new Date(timestamp || Date.now());
    var dateInfo = {
        Y: "".concat(date.getFullYear()),
        M: "".concat(date.getMonth() + 1),
        D: "".concat(date.getDate()),
        h: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds()
    };
    var formatNumber = function (n) { return (n > 10 ? n : '0' + n); };
    var res = (format || 'Y-M-D h:m:s')
        .replace('Y', dateInfo.Y)
        .replace('M', dateInfo.M)
        .replace('D', dateInfo.D)
        .replace('h', formatNumber(dateInfo.h))
        .replace('m', formatNumber(dateInfo.m))
        .replace('s', formatNumber(dateInfo.s));
    return res;
};
export function throttle(fn, delay) {
    var canRun = true;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!canRun)
            return;
        fn.apply(this, args);
        canRun = false;
        setTimeout(function () {
            canRun = true;
        }, delay);
    };
}
export function replaceOld(source, name, replacement, isForced) {
    if (source === undefined)
        return;
    if (name in source || isForced) {
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            source[name] = wrapped;
        }
    }
}
export function formatDecimal(num, decimal) {
    if (!num) {
        return num;
    }
    var str = num.toString();
    var index = str.indexOf('.');
    if (index !== -1) {
        str = str.substring(0, decimal + index + 1);
    }
    else {
        str = str.substring(0);
    }
    return parseFloat(str);
}
export function countBytes(str) {
    var encoder = new TextEncoder();
    return encoder.encode(str).length;
}
export function splitStringByBytes(str, maxBytes) {
    var encoder = new TextEncoder();
    var bytes = encoder.encode(str);
    var decoder = new TextDecoder();
    var chunks = [];
    var start = 0;
    while (start < bytes.length) {
        var end = start + maxBytes;
        while (end > start && (bytes[end] & 0xc0) === 0x80) {
            end--;
        }
        chunks.push(decoder.decode(bytes.subarray(start, end)));
        start = end;
    }
    return chunks;
}
